export default {"src":"/uk/_next/static/media/hsbc.c4adc83c.svg","height":409,"width":1516,"blurWidth":0,"blurHeight":0};